function syncPictureHeight() {
  const right = document.querySelector('.power-trio-right');
  if (!right) return;

  const content = right.querySelector('.power-trio-right-icons');
  const pictureImg = right.querySelector('.power-trio-picture img');
  const picture = right.querySelector('.power-trio-picture');
  if (!content || !pictureImg || !picture) return;

  // обмеження по ширині екрану
  if (window.innerWidth > 1439) {
    picture.style.height = '';
    pictureImg.style.width = '';
    pictureImg.style.objectFit = '';
    return;
  }

  // тимчасово ховаємо картинку, щоб не впливала на висоту
  pictureImg.style.display = 'none';

  // вимірюємо "візуальну" висоту контентного блока, враховуючи всі дочірні елементи
  const contentRect = content.getBoundingClientRect();
  const childrenRects = [...content.querySelectorAll('*')].map(el => el.getBoundingClientRect());
  const maxBottom = Math.max(contentRect.bottom, ...childrenRects.map(r => r.bottom));
  const visualHeight = maxBottom - contentRect.top;

  // повертаємо картинку
  pictureImg.style.display = '';

  // задаємо картинці висоту + запас 40px
  const contentHeight = visualHeight + 40;
  picture.style.height = contentHeight + 'px';
  pictureImg.style.width = 'auto';
  pictureImg.style.objectFit = 'cover';
}

window.addEventListener('load', syncPictureHeight);
window.addEventListener('resize', syncPictureHeight);